import React, { useState, useEffect } from 'react';
import { ToggleLeft } from 'lucide-react';
import Preloader from '../../components/Preloader';
import Permiso from '../../router/Permiso';
import { UsuarioService } from '../../services/UsuarioService';
import BajaModal from './BajaModal';
import { toast } from 'react-toastify';

const ListadoBaja = ({ token, refreshTrigger }) => {
    const [usuarios, setUsuarios] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState('');
    const [success, setSuccess] = useState('');
    const [currentPage, setCurrentPage] = useState(1);
    const [totalPages, setTotalPages] = useState(1);
    const [totalRegistros, setTotalRegistros] = useState(0);
    const [fechaInicio, setFechaInicio] = useState("");
    const [fechaFin, setFechaFin] = useState("");
    const [buscarNombre, setBuscarNombre] = useState("");
    const [showBajaModal, setShowBajaModal] = useState(false);
    const [selectedColaborador, setSelectedColaborador] = useState(null);
    const [bajaForm, setBajaForm] = useState({
        id_baja:"",
        motivo_baja: "",
        fecha_baja: "",
        comentario: "",
    });

    useEffect(() => {
        fetchUsuarios();
    }, [refreshTrigger, currentPage, buscarNombre, fechaInicio, fechaFin]);

    const fetchUsuarios = async () => {
        try {
            // Cargar postulantes citados
            const { usuarios, totalPages, totalRegistros } = await UsuarioService.fetchBajas({
                token,
                desde: fechaInicio,
                hasta: fechaFin,
                buscar: buscarNombre,
                page: currentPage,
                limit: 20,
            });
            setUsuarios(usuarios);
            setTotalPages(totalPages);
            setTotalRegistros(totalRegistros);
        } catch (err) {
            setError('Error al cargar usuarios');
            console.log("Error al cargar usuarios",err);
        } finally {
            setLoading(false);
        }
    };

    const handleBajaColaborador = (colaborador) => {
        setSelectedColaborador(colaborador);
        setBajaForm({
            id_baja:colaborador.id_baja,
            motivo_baja: "",
            fecha_baja: new Date().toISOString().split("T")[0],
            comentario: "",
        });
        setShowBajaModal(true);
        setError("");
    };

    const handleFormChange = (e) => {
        setBajaForm({
            ...bajaForm,
            [e.target.name]: e.target.value,
        });
    };

    const handleConfirmarBaja = async () => {
    
        try {
            await UsuarioService.darDeBajaUsuarioSolicitud({
                token,
                id: selectedColaborador.id,
                bajaForm,
            });

            toast.success("Usuario dabo de baja correctamente")
            setShowBajaModal(false);
            fetchUsuarios(); // Recargar la lista
        } catch (err) {
            setError("Error al dar de baja al colaborador");
            console.log("Error al dar de baja al colaborador",err);
        }
    };


    if (loading) return <Preloader />;

    return (
        <div className="usuarios-table-container">
            <div className="usuarios-table-header">
                <h2 className="usuarios-table-title">Listado de solicitudes de Bajas </h2>
            </div>

            <div className="usuarios-filtros">

                <div className="filtro-grupo">
                    <label htmlFor='fecha-inicio'>Fecha Inicio:</label>
                    <input
                        type="date"
                        value={fechaInicio}
                        onChange={(e) => setFechaInicio(e.target.value)}
                    />
                </div>
                <div className="filtro-grupo">
                    <label htmlFor='fecha-fin'>Fecha Fin:</label>
                    <input
                        type="date"
                        value={fechaFin}
                        onChange={(e) => setFechaFin(e.target.value)}
                    />
                </div>
                <div className="filtro-item">
                    <label htmlFor='buscar-nombre'>Buscar por Nombre:</label>
                    <input
                        type="text"
                        value={buscarNombre}
                        onChange={(e) => setBuscarNombre(e.target.value)}
                        placeholder="Nombre, apellido o nombre completo"
                    />
                </div>
                <div className="filtro-grupo">
                    <button
                        onClick={() => {
                            setFechaInicio("");
                            setFechaFin("");
                            setBuscarNombre("");

                            fetchUsuarios();
                        }}
                        className="btn-limpiar"
                    >
                        Limpiar Filtros
                    </button>
                </div>

            </div>

            {error && <div className="error-message">{error}</div>}
            {success && <div className="success-message">{success}</div>}

            <div className="ventas-table-wrapper">
                <table className="ventas-table">
                    <thead>
                        <tr>
                            <th>Tipo Documento</th>
                            <th>Número</th>
                            <th>Nombres y Apellidos</th>
                             <th>Motivo</th>
                            <th>Fecha de Solicitud</th>
                            <th>Acciones</th>
                        </tr>
                    </thead>
                    <tbody>
                        {loading ? (
                            <tr>
                                <td
                                    colSpan="6"
                                    style={{ textAlign: "center", padding: "40px" }}
                                >
                                    Cargando...
                                </td>
                            </tr>
                        ) : error ? (
                            <tr>
                                <td
                                    colSpan="6"
                                    style={{ textAlign: "center", padding: "40px" }}
                                >
                                    {error}
                                </td>
                            </tr>
                        ) : usuarios.length === 0 ? (
                            <tr>
                                <td
                                    colSpan="6"
                                    style={{ textAlign: "center", padding: "40px" }}
                                >
                                    No hay usuarios con solicitudes
                                </td>
                            </tr>
                        ) : (
                            usuarios.map((usuario) => (
                                <tr key={usuario.id}>
                                    <td>{usuario.tipo_documento || "-"}</td>
                                    <td>{usuario.numero_documento || "-"}</td>
                                    <td>{usuario.nombres || usuario.usuario || "-"}</td>
                                    <td>{usuario.descripcion_motivo_baja}</td>
                                    
                                    <td>{new Date(usuario.fecha_solicitud_baja).toLocaleString('es-PE', {
                                        day: '2-digit',
                                        month: '2-digit',
                                        year: 'numeric',
                                        hour: '2-digit',
                                        minute: '2-digit',
                                        second: '2-digit',
                                        hour12: true 
                                    })}
                                    </td>
                                    <td className="ventas-acciones">
                                        {usuario.estado !== "BAJA" && (
                                            <Permiso permiso="rrhh_solicitudes_baja_confirmar">
                                                <span onClick={() => handleBajaColaborador(usuario)}>
                                                    <ToggleLeft size={22} color="#e74c3c" />
                                                </span>
                                            </Permiso>
                                        )}
                                    </td>
                                </tr>
                            ))
                        )}
                    </tbody>
                </table>
            </div>

            <span style={{ marginLeft: "12px", fontSize: "14px", color: "#555" }}>
                {" "}
                Total de registros: {totalRegistros}{" "}
            </span>
            <div className="pagination">
                <button
                    onClick={() => setCurrentPage(currentPage - 1)}
                    disabled={currentPage === 1}
                >
                    Anterior
                </button>
                <span>
                    Página {currentPage} de {totalPages}
                </span>

                <button
                    onClick={() => setCurrentPage(currentPage + 1)}
                    disabled={currentPage === totalPages}
                >
                    Siguiente
                </button>
            </div>

            <BajaModal
                show={showBajaModal}
                colaborador={selectedColaborador}
                bajaForm={bajaForm}
                handleFormChange={handleFormChange}
                handleConfirmarBaja={handleConfirmarBaja}
                setShowBajaModal={setShowBajaModal}
                error={error}
                success={success}
            />

        </div>
    );
};

export default ListadoBaja; 